import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalRoot } from '@wix/da-ds/pkg/modals/base';
import Popover from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import s from './DiscountsPopup.scss';
const DiscountLineItem = ({ discount })=>{
    var _discount_amount;
    const { t } = useTranslation();
    if (discount === null || discount === void 0 ? void 0 : (_discount_amount = discount.amount) === null || _discount_amount === void 0 ? void 0 : _discount_amount.percent) {
        return /*#__PURE__*/ React.createElement("span", null, discount.amount.percent, "% ", t('common.off'), ' ', t(`popup.discounts.audience.var.${discount.audience}`));
    }
};
const DiscountsPopup = ({ isOpen = false, onRequestClose, discounts })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(ModalRoot, {
        className: s['root'],
        isOpen: isOpen,
        hasCloseButton: false,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ React.createElement(Popover, {
        className: s['popover'],
        heading: t('popup.discounts.title'),
        content: /*#__PURE__*/ React.createElement("div", {
            className: s['content']
        }, /*#__PURE__*/ React.createElement("ul", {
            className: s['list']
        }, discounts === null || discounts === void 0 ? void 0 : discounts.map((discount)=>/*#__PURE__*/ React.createElement("li", {
                key: discount.discountId,
                className: s['list-item']
            }, /*#__PURE__*/ React.createElement(DiscountLineItem, {
                discount: discount
            }))))),
        onCloseClick: onRequestClose
    }));
};
DiscountsPopup.displayName = 'DiscountsPopup';
export default DiscountsPopup;

//# sourceMappingURL=DiscountsPopup.js.map